import { Box, List, ListItem, Typography } from '@mui/material';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import { infoTextTooltipTariffs } from '../constants.tsx';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import { TTariff } from '~/queries/types';
import { styles } from '../styles';

interface ITariffList {
  tarrifs: TTariff[];
}

export const TariffList = ({ tarrifs }: ITariffList) => {
  const { isSoleTrader, isLegalResident } = useGetContragentTypes();

  if (!tarrifs.length) {
    return (
      <Typography variant="body2">
        Наразі немає доступних тарифів для юридичних осіб та фізичних осіб-підприємців.
      </Typography>
    );
  }

  let startedTariffText;

  if (isSoleTrader) {
    startedTariffText = 'Переглянути тарифи для юридичних осіб та фізичних осіб-підприємців';
  } else if (isLegalResident) {
    startedTariffText = 'Переглянути тарифи для юридичних осіб';
  } else {
    startedTariffText = 'Переглянути тарифи';
  }

  return (
    <Box>
      <Typography variant="body2">{startedTariffText}</Typography>
      <List sx={styles.tariffList}>
        {tarrifs.map((tariff, index) => {
          const tooltipText =
            infoTextTooltipTariffs[tariff.tariffId as keyof typeof infoTextTooltipTariffs];

          return (
            <ListItem key={index} sx={styles.tariffListItem}>
              {tariff.url ? (
                <Typography
                  variant="body2"
                  sx={{ position: 'relative' }}
                  component="a"
                  href={tariff.url}
                  target="_blank"
                >
                  {tariff.name}
                  {tooltipText && <InfoTooltip title={tooltipText} iconStyles={styles.infoIcon} />}
                </Typography>
              ) : (
                <Typography>{tariff.name}</Typography>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
